import React, { useEffect } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import CartDrawer from "../components/CartDrawer";
import BlockRenderer from "../components/Blocks";
import { useStore } from "../context/StoreContext";

export default function HomePage() {
  const { bootstrap } = useStore();
  useEffect(() => {
    document.title = `${bootstrap?.settings?.store_name || "ZEFERIUS"} — Loja Oriental Premium`;
  }, [bootstrap]);

  if (!bootstrap) {
    return <div className="min-h-screen bg-background" data-testid="home-loading" />;
  }

  return (
    <div data-testid="home-page">
      <Header />
      <CartDrawer />
      <main>
        <BlockRenderer
          blocks={bootstrap.blocks}
          categories={bootstrap.categories}
          banners={bootstrap.banners}
          dragons={bootstrap.dragons}
          settings={bootstrap.settings}
        />
      </main>
      <Footer />
    </div>
  );
}
